<template>
  <div class="container container--max-750">
    <h1 class="h3 mt-lg-3 c-icon-headline mb-6">
      <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <circle fill="#5DA70B" cx="20" cy="20" r="20"></circle>
          <path
            d="M25.3 17.2v-2.9c-.1-2.6-2.4-4.8-5.2-4.9-2.6-.1-5.1 1.9-5.4 4.4l-2.3-.5c.5-2.9 2.7-5.3 5.5-6 4.8-1.3 9.6 2.3 9.6 7.3v3.3h.6c.9.1 1.5.7 1.5 1.6v9.8c0 1-.7 1.7-1.7 1.7H11.8c-1.1 0-1.8-.6-1.8-1.8v-9.5c0-1.2.6-1.7 1.7-1.8H25.1l.2-.7z"
            fill="#FFF"
          ></path>
        </g>
      </svg>
      <span>{{ $i18n.t("lang.label_keypairDownload_title") }}</span>
    </h1>

    <p>{{ $i18n.t("lang.label_keypairDownload_description") }}</p>

    <div>
      <b-form>
        <b-form-group id="input-group-keypair" :label="$i18n.t('lang.label_keypairDownload_keypair')" label-for="button-keypair">
          <b-button @click="downloadKeystoreFile" id="button-keypair" variant="primary" class="btn--has-icon">
            <mtg-icon icon="ic-download" viewBox="0 0 24 24"></mtg-icon>
            <span>{{ $i18n.t("lang.label_keypairDownload_download") }}</span>
            <span>(PKCS12)</span>
          </b-button>
        </b-form-group>

        <b-form-group id="input-group-password2" :label="$i18n.t('lang.label_keypairDownload_password')" label-for="input-password">
          <b-input-group>
            <b-form-input id="input-password" v-model="keypairPassword" :type="showPassword ? 'text' : 'password'" readonly></b-form-input>
            <b-input-group-append>
              <b-button @click="toggleShowPassword" variant="outline-primary">
                <b-icon v-if="!showPassword" icon="eye-fill"></b-icon>
                <b-icon v-if="showPassword" icon="eye-slash-fill"></b-icon>
              </b-button>
              <b-button @click="copyPasswordToClipboard" variant="outline-primary" class="btn--has-icon">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.88 6.014v15.412a.453.453 0 01-.454.453H6.014a.453.453 0 01-.454-.453v-4.08h11.333c.25 0 .453-.202.453-.453V5.56h4.08c.25 0 .453.203.453.454zM15.985 16.44H.574a.453.453 0 01-.453-.454V.574A.453.453 0 01.574.12h15.412c.25 0 .454.203.454.453v15.412c0 .25-.203.454-.454.454z"
                    fill="currentColor"
                    fill-rule="evenodd"
                  ></path>
                </svg>
                <span>{{ $i18n.t("lang.label_copyToClipboard") }}</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form>
    </div>

    <b-form-group id="input-group-confirm-proceed">
      <b-form-checkbox v-model="userConfirmed" :state="hasUserConfirmed" id="checkbox-confirm" name="checkbox-confirm" value="yes" unchecked-value="no">
        <span>{{ $i18n.t("lang.label_keypairDownload_checkboxConfirm") }}</span>
      </b-form-checkbox>
    </b-form-group>
    <div class="text-right">
      <b-button replace :to="{ name: 'certificate-detail', params: { id: id } }" :disabled="!hasUserConfirmed" variant="primary">{{ $i18n.t("lang.label_keypairDownload_goToCertificate") }}</b-button>
    </div>
  </div>
</template>
<script>
import { BIcon, BIconEyeFill, BIconEyeSlashFill } from "bootstrap-vue";
import * as utils from "@/utils";

export default {
  name: "CreateCertificateKeypairDownload",
  props: {
    id: {
      required: true
    },
    keypairFile: {
      type: String,
      required: true
    },
    keypairPassword: {
      type: String,
      required: true
    },
    keypairFilename: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showPassword: false,
      userConfirmed: "no"
    };
  },
  computed: {
    hasUserConfirmed() {
      this.$store.dispatch("certificate/getCertificateStatisticsForUser"); // we need to reload statistics for Issued Certificates
      return this.userConfirmed === "yes";
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasUserConfirmed) {
      if (!window.confirm(this.$t("lang.message_keypairDownload_areYouSure"))) {
        this.$store.dispatch("certificate/getCertificateStatisticsForUser"); // we need to reload statistics for Issued Certificates
        return;
      }
    }
    next();
  },
  methods: {
    preventNav(event) {
      if (this.hasUserConfirmed) return;
      event.preventDefault();
      event.returnValue = ""; // Chrome requires returnValue to be set.
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    copyPasswordToClipboard() {
      this.$copyText(this.keypairPassword).catch(() => {
        this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_revokedOrExpired_message"));
      });
    },
    downloadKeystoreFile() {
      utils.downloadBase64File(this.keypairFilename, this.keypairFile);
    }
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    BIcon,
    BIconEyeFill,
    BIconEyeSlashFill
  }
};
</script>
